/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { ApiTokenHeader } from "app/models/api-token";
import { ConfirmDeleteDialogComponent } from "../confirm-delete-dialog.component";
import { ApiTokenService } from "../../services/apitoken.service";
import { ActivatedRoute } from "@angular/router";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "../simple-success-error-dialog-box/simple-success-error-dialog-box.component";
import { PagedResults } from "app/models/paged-results";
import { RESULTS_PER_PAGE } from "app/app-constants";
import { SimpleIndefiniteProgressDialogComponent } from '../simple-indefinite-progress-dialog/simple-indefinite-progress-dialog.component';
import { UserService } from '../../services/user.service';
import { User } from 'app/models/user';
/** Declare $ to call bootstrap */
declare var $: any;

@Component({
    selector: 'app-api-token',
    templateUrl: './apiToken.component.html'

})
export class ApiTokenComponent implements OnInit {

    /** Progress Dialog displayed when performing actions to give the User an indication something is happening... */
    @ViewChild(SimpleIndefiniteProgressDialogComponent) indefiniteProgressDialog: SimpleIndefiniteProgressDialogComponent;

    @ViewChild('confirmDeleteDialog')
    confirmDialog: ConfirmDeleteDialogComponent;

    /** Reference to the SimpleSuccessErrorDialog used to display error */
    @ViewChild('successErrorDialog')
    simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent



    /** List Of API TOKEN being displayed in the UI */
    tokenHeaders: ApiTokenHeader[] = [];

    @ViewChild('apiTokenModal') apiTokenModal: any;

    /* Paging Variables */
    numberOfToken = 0;
    totalNumberOfToken = 0;
    currentPageForToken = 1;
    resultsPerPageValues = RESULTS_PER_PAGE;
    selectedPageSizeValueForToken: number = this.resultsPerPageValues[0];
    users: User[] = [];

    /** Constructor */
    constructor(
        private apiTokenService: ApiTokenService,
        private mRoute: ActivatedRoute,
        private mUserService: UserService,
    ) { }

    filterColumnToken = null;
    filterColumnNameToken = "";
    filterStringToken = "";
    description: string = '';
    selectedUserLogin: string = '';
    selectedUserId: number | null = null;


    ngOnInit(): void {

        // Subscribe to the Route to get the Rules that get loaded as it is resolved
        this.mRoute.data.subscribe((data: { tokenHeaders: PagedResults<ApiTokenHeader> }) => {
            //Set the initial values for Pagination
            const results = data.tokenHeaders;
            this.tokenHeaders.push(...results.data);
            this.totalNumberOfToken = results.size;

        });
        this.loadUsers();
    }

    loadUsers(): void {
        this.mUserService.getAllUsers().then(
            users => {
                this.users = users;
                console.log("Users loaded:", users);
            },
            error => {
                this.handleError(error);
            }
        );
    }



    selectAll(event: Event): void {
        const checked = (event.target as HTMLInputElement).checked;
        this.tokenHeaders.forEach(header => header.selected = checked);
    }

    isAllSelected(): boolean {
        return this.tokenHeaders.every(header => header.selected);
    }

    isEmptySelection(): boolean {
        return this.tokenHeaders.filter(header => header.selected).length === 0;
    }

    onDelete(): void {
        if (!this.isEmptySelection()) {
            const token: string[] = this.tokenHeaders
                .filter(header => header.selected)
                .map(header => header.apiToken);

            this.confirmDialog.show("Delete ApiToken", token);
        }
    }

    getSelectedGtinIds(): number[] {
        return this.tokenHeaders
            .filter(header => header.selected)
            .map(header => header.id);
    }

    deleteApiToken(): void {
        const selectedIds = this.getSelectedGtinIds();

        this.apiTokenService.deleteTokens(selectedIds).then(
            response => {
                this.refreshTokenHeaders(); // Refresh the list
            },
            error => {
                this.handleError(error); // Handle any errors
            }
        );
    }

    /**
       * Refreshes the page of api Tokens  being displayed
       */
    private async refreshTokenHeaders(): Promise<void> {
        // Make the API call
        let page: PagedResults<ApiTokenHeader> = null;
        try {
            page = await this.apiTokenService.getApiTokenHeaders((this.currentPageForToken - 1) * this.selectedPageSizeValueForToken, this.selectedPageSizeValueForToken, 'DESC', this.filterStringToken);
        } catch (error) {
            this.handleError(error);
            return;
        }

        // Clear the current list
        while (this.tokenHeaders.length > 0) {
            this.tokenHeaders.pop();
        }

        // Add the data for the current list
        if (page.data?.length > 0) {
            this.tokenHeaders.push(...page.data);
        }

        // Update the total size for paging
        console.log("page.size" + page.size);
        this.totalNumberOfToken = page.size;
    }
    /**
   * Displays the error to the User
   */
    handleError(error: any): void {
        /* New handling (TJB 04/18/2023) */
        if (error?.error != null) {
            this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.error);
        }

        /* Default back to old handling */
        else if (error != null) {
            const response: Response = error;
            this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.text);
        }
    }

    onUserSelected(event: any) {
        const user: User = event.item;
        this.selectedUserId = user.id;
        this.selectedUserLogin = user.login;
        console.log('Selected user:', this.selectedUserId);
    }



    onCreateClicked(): void {
        if (!this.description) {
            this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, 'Please enter the description.');
            return;
        }

        if (!this.selectedUserId) {
            this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, 'Please select a User.');
            return;
        }
        const tokenRequest = new ApiTokenHeader();
        tokenRequest.description = this.description;
        tokenRequest.userId = this.selectedUserId;

        this.apiTokenService.createToken(tokenRequest).then(
            response => {
                $("#apiToken").modal("hide");
                this.description = "";
                this.selectedUserId = null;
                this.selectedUserLogin = "";
                this.refreshTokenHeaders(); // Refresh the list
            },
            error => {
                this.handleError(error); // Handle any errors
            }
        );

    }

    onCancelClicked(): void {
        $("#apiToken").modal("hide");
        this.description = "";
        this.selectedUserId = null;
        this.selectedUserLogin = "";
    }



    pageChanged(pageNumber: number): void {
        console.log("pageNumber" + pageNumber);
        if (pageNumber == null || pageNumber == undefined || pageNumber < 1) {
            return;
        }
        if (this.currentPageForToken == pageNumber) {
            return;
        }
        this.currentPageForToken = pageNumber;
        this.refreshTokenHeaders();
    }

    manageResultPerPageClickedForToken(value: number): void {
        this.selectedPageSizeValueForToken = value;

        // Selecting any value will bring you back to first page
        this.currentPageForToken = 1;
        this.refreshTokenHeaders();
    }


}